import { Check, X } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const FOR_YOU = [
    "prowadzisz zajęcia indywidualne z dorosłymi",
    "uczysz grupy lub prowadzisz kursy firmowe",
    "chcesz lepiej prowadzić konwersacje",
    "spotykasz się z trudnymi zachowaniami albo spadkiem motywacji",
    "chcesz mieć konkretne strategie, a nie samą teorię",
    "dopiero zaczynasz pracę z dorosłymi lub masz doświadczenie i szukasz nowych sposobów działania",
];

const NOT_FOR_YOU = [
    "szukasz gotowego podręcznika lub kompletnego kursu językowego dla ucznia",
    "interesuje Cię wyłącznie teoria",
    "nie pracujesz i nie planujesz pracować z dorosłymi uczniami",
];

export const ForWhom = () => (
    <section data-testid="target-audience-section" className="py-20 sm:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading kicker="Dla kogo" title="Sprawdź, czy ten kurs jest o Tobie" />
            <div className="mt-12 grid lg:grid-cols-2 gap-6">
                <Reveal>
                    <article
                        data-testid="for-you-card"
                        className="h-full rounded-3xl bg-tang text-ink p-8 sm:p-10 shadow-pop relative overflow-hidden"
                    >
                        <span className="absolute -right-16 -top-16 w-56 h-56 rounded-full border-[22px] border-ink/10" />
                        <h3 className="font-display uppercase text-2xl font-bold">
                            Ten kurs jest dla Ciebie, jeśli…
                        </h3>
                        <ul className="mt-7 space-y-4">
                            {FOR_YOU.map((item) => (
                                <li key={item} className="flex gap-3 items-start">
                                    <span className="shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-full bg-ink text-white mt-0.5">
                                        <Check className="w-3.5 h-3.5" strokeWidth={3} />
                                    </span>
                                    <span className="text-[15px] leading-relaxed">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </article>
                </Reveal>
                <Reveal delay={0.12}>
                    <article
                        data-testid="not-for-you-card"
                        className="h-full rounded-3xl bg-cream-deep border border-border p-8 sm:p-10"
                    >
                        <h3 className="font-display text-2xl font-bold text-ink">
                            To nie jest kurs dla Ciebie, jeśli…
                        </h3>
                        <ul className="mt-7 space-y-4">
                            {NOT_FOR_YOU.map((item) => (
                                <li key={item} className="flex gap-3 items-start">
                                    <span className="shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-full bg-ink/5 text-ink-soft mt-0.5">
                                        <X className="w-3.5 h-3.5" strokeWidth={3} />
                                    </span>
                                    <span className="text-[15px] text-ink-soft leading-relaxed">
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </article>
                </Reveal>
            </div>
        </div>
    </section>
);
